/**
 * App Init
 * --------------------------------------------------------------------------------------------------
 */
export default defineNuxtPlugin(() => {
    logSentryBreadcrumb('App initialized on client');
});
